import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { emailAddress, phoneNumber, phoneNumberLink } from 'utils/helpers';
import ErrorDialogModal from 'components/error_dialog';
import { getCurrentBooking } from 'redux/selectors/current_booking';

const ErrorDialog = ({ code, close, show }) => {
  const currentBooking = useSelector(getCurrentBooking);

  useEffect(() => {
    if (!window.dataLayer) {
      return;
    }

    window.dataLayer.push({
      event: 'exception',
      description: 'Displayed availability error',
    });
  }, []);

  return (
    <ErrorDialogModal
      title="We're here to help"
      handleClose={close}
      show={show}
    >
      <div className="text-center">
        <p>
          {code === 422 ? (
            <>
              Unfortunately this product cannot be booked based on your
              selection.
              {!isEmpty(currentBooking) && (
                <>
                  {' '}
                  Please try an alternate search, call us on{' '}
                  <a href={`tel:${phoneNumberLink}`}>{phoneNumber}</a> or
                  <a href={`mailto:${emailAddress}`}>email us</a> and quote your
                  booking reference <b>{currentBooking.reference}</b>.
                </>
              )}
            </>
          ) : (
            <>Error creating reservation</>
          )}
        </p>
      </div>
    </ErrorDialogModal>
  );
};

ErrorDialog.propTypes = {
  code: PropTypes.number,
  show: PropTypes.bool,
  close: PropTypes.func,
};

export default ErrorDialog;
